import { render, staticRenderFns } from "./inputMaterialWrap.vue?vue&type=template&id=6a776502&"
import script from "./inputMaterialWrap.vue?vue&type=script&lang=js&"
export * from "./inputMaterialWrap.vue?vue&type=script&lang=js&"
import style0 from "./inputMaterialWrap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports